import { useQuery } from '@tanstack/react-query';
import { getRequestById } from './httpCalls';
import { enqueueSnackbar } from 'notistack';

export function useGetRequestById(id, enabled = true) {
  return useQuery({
    queryFn: () => getRequestById(id),
    queryKey: ['getRequestByID', id],
    enabled: enabled && Boolean(id),
    onSuccess: () => {
      enqueueSnackbar('Επιτυχία!', {
        variant: 'success',
        autoHideDuration: 2000,
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || 'Κάτι πήγε στραβά', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    },
  });
}
